<template>
  <div class="">

    <el-row>
      <el-col :span="24">

        <div class="card">
          <div class="card-body row">
            <div v-if="id_project" class="col-sm-3 title"> Samples of project {{ g_project.name }} </div>
            <div v-else class="col-sm-3"> </div>

            <!-- <div class="col-sm-2 ml-auto mr-auto">
              <el-tooltip v-show="true" content="Select type of visualisation" placement="top" effect="light" :open-delay="300">
                <el-switch
                  style="display: block"
                  v-model="exam_visualisation"
                  @change="exam_visualisation_change"
                  active-text="By Exam"
                  inactive-text="By Group"
                  >
                </el-switch>
              </el-tooltip>
            </div>

            <div class="col-sm-5 ml-auto mr-auto">
              <el-select class="select-info"
                        placeholder="Select Samples"
                        multiple
                        size="small"
                        style="width: 90%"
                        v-model="xxxxxxxxx"
                        >
                <el-option v-for="option in examinations_data"
                          class="select-info"
                          :value="option.id_examination"
                          :label="option.sample_id"
                          :key="option.id_examination"
                          >
                </el-option>
              </el-select>
            </div> -->

            <div class="col-sm-9">
              <div class="pull-right">
                <el-input size="medium"
                          placeholder="Search"
                          v-model="searchQuery_e"
                          suffix-icon="icofont-search-2">
                </el-input>
              </div>
            </div>

            <div class="col-sm-12 mt-2">
              <el-table class=""
                ref="examinations"
                :data="examinations_data"
                border
                v-loading="loading_e"
                element-loading-text="Loading..."
                element-loading-spinner="icofont-refresh icofont-5x"
                element-loading-background="rgba(100, 100, 100, 0.5)"
                highlight-current-row
                :default-sort="{prop: 'id_examination', order: 'ascending'}"
                @current-change="handleCurrentChange"
                @selection-change="handleSelectionChange"
                style="width: 100%"
                :row-class-name="tableRowClassName"
              >
                <template slot="empty">
                    <div v-if="loading_e">
                    </div>
                    <div v-else style="font-size: 20px; font-weight: 800; text-align: left">
                      No examinations found
                    </div>
                </template>
                <el-table-column
                  prop="id_examination"
                  label="ID"
                  min-width="50"
                  align="left"
                  sortable
                  >
                </el-table-column>

                <el-table-column
                  type="selection"
                  width="55"
                  >
                </el-table-column>

                <el-table-column
                  prop="sample_id"
                  label="Sample ID"
                  min-width="120"
                  align="left"
                  sortable
                  >
                  <template slot-scope="scope">
                    <el-tooltip v-if="scope.row.data_quality !== '' && scope.row.status > 9" placement="top" effect="light" :open-delay="200">
                      <div slot="content" v-html="scope.row.data_quality"></div>
                      <el-tag size="mini" effect="dark" type="warning"><i class="icofont-exclamation-square"></i></el-tag>
                    </el-tooltip>
                    <el-tooltip v-if="scope.row.data_quality === '' && scope.row.status > 9" content="Quality status is OK." placement="top" effect="light" :open-delay="200">
                      <el-tag size="mini" effect="dark" type="success"><i class="icofont-check"></i></el-tag>
                    </el-tooltip>

                    {{ scope.row.sample_id }}
                  </template>
                </el-table-column>

                <el-table-column v-if="false"
                  prop="sample_name"
                  label="SampleName"
                  min-width="100"
                  align="left"
                  sortable
                  >
                </el-table-column>

                <el-table-column v-if="false"
                  label="Patient"
                  min-width="150"
                  align="center"
                  >
                  <template v-if="scope.row.hash > ''" slot-scope="scope">
                      <el-tag size="small" type="success" effect="plain" @click="handlePatient(scope.row, $event)">{{ scope.row.patname }}</el-tag>
                  </template>
                </el-table-column>

                <el-table-column
                  label="Status"
                  min-width="70"
                  align="center"
                  prop="status"
                  sortable
                  >
                  <template slot-scope="scope">
                      <el-tag v-if="scope.row.status === 0" size="small" effect="plain"> NEW </el-tag>
                      <el-tag v-else-if="scope.row.status === 1" size="small" effect="dark"> UPLOADED </el-tag>
                      <el-tag v-else-if="scope.row.status === 2" size="small" type="danger" effect="dark"> WRONG </el-tag>
                      <el-tag v-else-if="scope.row.status === 3" size="small" type="warning" effect="plain"> SUBMITTED </el-tag>
                      <el-tag v-else-if="scope.row.status === 4" size="small" type="warning" effect="dark"> RUNNING </el-tag>
                      <el-tag v-else-if="scope.row.status === 8" size="small" type="warning" effect="plain"> RUNNING </el-tag>
                      <el-tag v-else-if="scope.row.status === 9" size="small" type="warning" effect="dark"> RUNNING </el-tag>
                      <el-tag v-else-if="scope.row.status === 10" size="small" type="success" effect="plain"> FINISHED </el-tag>
                      <el-tag v-else-if="scope.row.status === 11" size="small" type="success" effect="dark"> FINISHED </el-tag>
                      <el-tag v-else-if="scope.row.status === 12" size="small" type="info" effect="dark"> PASSED </el-tag>
                      <el-tag v-else-if="scope.row.status === 15" size="small" type="default" effect="dark"> SIGNED OUT </el-tag>
                      <el-tag v-else-if="scope.row.status === -5" size="small" type="danger" effect="dark"> MISSING DATA </el-tag>
                      <el-tag v-else size="small" type="default" effect="plain">  </el-tag>
                  </template>
                </el-table-column>

                <el-table-column
                  v-if="rapp === 'genetify'"
                  prop="input_reads"
                  label="Input reads"
                  min-width="80"
                  align="center"
                  sortable
                  >
                  <template v-if="scope.row.input_reads" slot-scope="scope">
                    {{ scope.row.input_reads.toLocaleString('cs-CZ') }}
                  </template>
                </el-table-column>

                <el-table-column
                  v-if="rapp === 'genetify'"
                  prop="reads_after_analysis"
                  label="Reads after"
                  min-width="80"
                  align="center"
                  sortable
                  >
                  <template v-if="scope.row.reads_after_analysis" slot-scope="scope">
                    {{ scope.row.reads_after_analysis.toLocaleString('cs-CZ') }}
                  </template>
                </el-table-column>

                <el-table-column
                  v-if="rapp === 'genetify'"
                  prop="total_loss"
                  label="Total loss"
                  min-width="80"
                  align="center"
                  sortable
                  >
                  <template v-if="scope.row.total_loss" slot-scope="scope">
                    {{ scope.row.total_loss.toLocaleString('cs-CZ') }}
                  </template>
                </el-table-column>

                <el-table-column
                  v-if="rapp === 'genetify'"
                  prop="shannon"
                  label="Shannon"
                  min-width="80"
                  align="center"
                  sortable
                  >
                  <template v-if="scope.row.shannon" slot-scope="scope">
                    {{ scope.row.shannon.toLocaleString('cs-CZ') }}
                  </template>
                </el-table-column>

                <el-table-column
                  v-if="rapp === 'genetify'"
                  prop="fb_ratio"
                  label="FB ratio"
                  min-width="80"
                  align="center"
                  sortable
                  >
                  <template v-if="scope.row.fb_ratio" slot-scope="scope">
                    {{ scope.row.fb_ratio.toLocaleString('cs-CZ') }}
                  </template>
                </el-table-column>

                <el-table-column
                  v-if="rapp === 'genetify'"
                  prop="enterotype"
                  label="Enterotype"
                  min-width="80"
                  align="center"
                  sortable
                  >
                  <template v-if="scope.row.enterotype" slot-scope="scope">
                    {{ scope.row.enterotype.toLocaleString('cs-CZ') }}
                  </template>
                </el-table-column>

                <el-table-column
                  v-if="rapp !== 'genetify'"
                  prop="total_reads"
                  label="Total reads"
                  min-width="80"
                  align="center"
                  sortable
                  >
                  <template slot-scope="scope">
                    <span v-if="scope.row.total_reads > 0"> {{ scope.row.total_reads.toLocaleString('cs-CZ') }} </span>
                    <span v-else> {{ scope.row.total_reads }} </span>
                  </template>
                </el-table-column>

                <el-table-column
                  v-if="rapp !== 'genetify'"
                  prop="varcount"
                  label="Total Variants"
                  min-width="60"
                  align="center"
                  >
                </el-table-column>

                <el-table-column
                  v-if="g_project.id_analysis_type < 100 && rapp !== 'genetify'"
                  prop="median_target_coverage"
                  label="Median depth"
                  min-width="75"
                  align="center"
                  sortable
                  >
                </el-table-column>

                <el-table-column
                  v-if="g_project.id_analysis_type < 100 && rapp !== 'fastras' && rapp !== 'genetify'"
                  prop="pct_exc_dupe"
                  label="% Duplicates"
                  min-width="75"
                  align="center"
                  sortable
                  >
                </el-table-column>

                <el-table-column
                  v-if="g_project.id_analysis_type < 100 && rapp !== 'genetify'"
                  prop="pct_target_bases_30x"
                  label="% Depth 30X"
                  min-width="70"
                  align="center"
                  sortable
                  >
                </el-table-column>

                <el-table-column
                  v-if="g_project.id_analysis_type < 100 && rapp !== 'genetify'"
                  prop="pct_target_bases_100x"
                  label="% Depth 100X"
                  min-width="70"
                  align="center"
                  sortable
                  >
                </el-table-column>

                <el-table-column
                  v-if="(rapp !== 'fastras') && false"
                  prop="statim"
                  label="Statim"
                  min-width="50"
                  align="center"
                  sortable
                  >
                  <template v-if="scope.row.statim" slot-scope="scope">
                    <el-tag size="small" type="danger" effect="plain"> YES </el-tag>
                  </template>
                </el-table-column>

                <!-- RNA QC: aligned reads -->
                <el-table-column
                  v-if="g_project.id_analysis_type > 100"
                  prop="aligned_reads_pct"
                  min-width="80"
                  align="center"
                  sortable
                >
                  <template #header>
                    <el-tooltip
                      placement="top"
                      effect="light"
                      :open-delay="500"
                      popper-class="custom-tooltip"
                    >
                      <div slot="content">
                        <b>Aligned reads</b><br>
                        Percentage of reads that could be successfully assigned to the reference.<br>
                        In simple terms: how much of the sequencing data could be used meaningfully.<br><br>
                        <b>Expected values:</b> usually above 80, very good above 90.<br>
                        Low values may suggest poor sample quality, contamination, or a technical issue.
                      </div>
                      <span style="cursor: help; text-decoration: underline;">Aligned %</span>
                    </el-tooltip>
                  </template>
                </el-table-column>

                <el-table-column
                  v-if="g_project.id_analysis_type > 100"
                  prop="pct_usable_bases"
                  min-width="80"
                  align="center"
                  sortable
                >
                  <template #header>
                    <el-tooltip
                      placement="top"
                      effect="light"
                      :open-delay="500"
                      popper-class="custom-tooltip"
                    >
                      <div slot="content">
                        <b>Usable bases</b><br>
                        Percentage of sequencing data that remained useful for the RNA analysis.<br>
                        In simple terms: how much of the data actually contributes to the final result.<br><br>
                        <b>Expected values:</b> higher is better; usually above 50–60 is acceptable.<br>
                        Low values mean that a large part of the data was not informative for analysis.
                      </div>
                      <span style="cursor: help; text-decoration: underline;">Usable %</span>
                    </el-tooltip>
                  </template>
                </el-table-column>

                <el-table-column
                  v-if="g_project.id_analysis_type > 100"
                  prop="median_cv_coverage"
                  min-width="80"
                  align="center"
                  sortable
                >
                  <template #header>
                    <el-tooltip
                      placement="top"
                      effect="light"
                      :open-delay="500"
                      popper-class="custom-tooltip"
                    >
                      <div slot="content">
                        <b>Coverage uniformity</b><br>
                        Shows how evenly the relevant regions are covered by sequencing data.<br>
                        In simple terms: whether the data are balanced across the tested regions.<br><br>
                        <b>Expected values:</b> lower is better.<br>
                        Values below 1 are generally good; values around 0.5 or lower are very good.<br>
                        Higher values indicate less even coverage and may reduce confidence in weakly covered regions.
                      </div>
                      <span style="cursor: help; text-decoration: underline;">Cov. CV</span>
                    </el-tooltip>
                  </template>
                </el-table-column>

                <el-table-column
                  v-if="g_project.id_analysis_type > 100"
                  prop="pct_ribosomal_bases"
                  min-width="75"
                  align="center"
                  sortable
                >
                  <template #header>
                    <el-tooltip
                      placement="top"
                      effect="light"
                      :open-delay="500"
                      popper-class="custom-tooltip"
                    >
                      <div slot="content">
                        <b>Ribosomal RNA</b><br>
                        Percentage of data coming from ribosomal RNA, which is usually not the main target of RNA analysis.<br>
                        In simple terms: how much sequencing capacity was spent on less useful RNA signal.<br><br>
                        <b>Expected values:</b> lower is better; ideally below 10–20.<br>
                        High values may indicate inefficient removal or depletion of ribosomal RNA.
                      </div>
                      <span style="cursor: help; text-decoration: underline;">rRNA %</span>
                    </el-tooltip>
                  </template>
                </el-table-column>

                <el-table-column
                  v-if="g_project.id_analysis_type > 100"
                  prop="pct_coding_bases"
                  min-width="80"
                  align="center"
                  sortable
                >
                  <template #header>
                    <el-tooltip
                      placement="top"
                      effect="light"
                      :open-delay="500"
                      popper-class="custom-tooltip"
                    >
                      <div slot="content">
                        <b>Coding bases</b><br>
                        Percentage of data located in protein-coding parts of genes.<br>
                        In simple terms: how much of the data directly comes from regions that encode proteins.<br><br>
                        <b>Expected values:</b> higher is better; values above 30–40 are usually good.<br>
                        Low values may mean that less data are available from the most clinically informative regions.
                      </div>
                      <span style="cursor: help; text-decoration: underline;">Coding %</span>
                    </el-tooltip>
                  </template>
                </el-table-column>

                <el-table-column
                  v-if="g_project.id_analysis_type > 100"
                  prop="pct_mrna_bases"
                  min-width="75"
                  align="center"
                  sortable
                >
                  <template #header>
                    <el-tooltip
                      placement="top"
                      effect="light"
                      :open-delay="500"
                      popper-class="custom-tooltip"
                    >
                      <div slot="content">
                        <b>mRNA bases</b><br>
                        Percentage of data coming from messenger RNA, which reflects gene activity.<br>
                        In simple terms: how much of the useful biological RNA signal is present in the sample.<br><br>
                        <b>Expected values:</b> higher is better; high-quality samples often show values above 50.<br>
                        Low values may suggest poor RNA quality or a high proportion of non-informative RNA.
                      </div>
                      <span style="cursor: help; text-decoration: underline;">mRNA %</span>
                    </el-tooltip>
                  </template>
                </el-table-column>

                <el-table-column
                  :min-width="150"
                  fixed="right"
                  class-name="td-actions"
                  label="Actions">
                  <template slot-scope="props">
                    <el-tooltip v-if="rapp !== 'genetify' && id_biorole > 3" content="Manage files of examination" placement="top" effect="light" :open-delay="500">
                      <el-button type="primary" size="mini" @click="handle_exam_files(props.$index, props.row, $event)">
                        <i class="icofont-edit"></i>
                      </el-button>
                    </el-tooltip>

                    <el-tooltip v-if="rapp !== 'genetify' && id_biorole > 3" content="Manage data of examination" placement="top" effect="light" :open-delay="500">
                      <el-button type="primary" size="mini" @click="handle_exam_detail(props.$index, props.row, $event)">
                        <i class="icofont-tasks"></i>
                      </el-button>
                    </el-tooltip>

                    <!-- <el-tooltip content="Make report" placement="top" effect="light" :open-delay="500">
                      <el-button type="success" size="sm" @click="handle_make_report(props.$index, props.row, $event)">
                        <i class="icofont-patient-file"></i>
                      </el-button>
                    </el-tooltip> -->
                    <el-tooltip v-if="props.row.status > 0 && props.row.status === 2" content="Valide examination" placement="top" effect="light" :open-delay="500">
                      <el-button type="warning" size="mini" @click="handle_exam_validate(props.$index, props.row, $event, type='BP')">
                        <i class="icofont-check-circled"></i>
                      </el-button>
                    </el-tooltip>
                    <el-tooltip v-if="rapp !== 'genetify' && props.row.status > 9" content="Mapping QC" placement="top" effect="light" :open-delay="500">
                      <el-button type="info" size="mini" @click.prevent="handleModalQC( props.$index, props.row, $event, 'Q')">
                        <i class="icofont-chart-bar-graph"></i>
                      </el-button>
                    </el-tooltip>
                    <el-tooltip v-if="props.row.status > 9" content="FASTQ QC" placement="top" effect="light" :open-delay="500">
                      <el-button type="info" size="mini" @click.prevent="handleShowQC( props.$index, props.row, $event, 'M')">
                        <i class="icofont-chart-pie"></i>
                      </el-button>
                    </el-tooltip>
                    <el-tooltip v-if="(props.row.status > 9) && props.row.undercovered_reg" content="UNDERCOVERED REGION" placement="top" effect="light" :open-delay="500">
                      <el-button type="warning" size="mini" @click.prevent="handleShowUCR( props.$index, props.row, $event, 'M')">
                        <i class="icofont-align-center"></i>
                      </el-button>
                    </el-tooltip>
                    <el-tooltip v-if="props.row.status > 9 && props.row.msi_tmb" content="MSI, TMB and HRD" placement="top" effect="light" :open-delay="500">
                      <el-button type="info" size="mini" @click.prevent="handleModalMSI_TMB( props.$index, props.row, $event, 'M')">
                        <i class="icofont-pills"></i>
                      </el-button>
                    </el-tooltip>
                    <el-tooltip v-if="props.row.status > 9 && props.row.status < 12" content="Pass QC and show variants" placement="top" effect="light" :open-delay="500">
                      <el-button type="warning" size="mini" @click="handle_exam_validate(props.$index, props.row, $event, type='AP')">
                        <i class="icofont-checked"></i>
                      </el-button>
                    </el-tooltip>
                    <el-tooltip v-if="props.row.status < 3" content="Remove examination" placement="top" effect="light" :open-delay="500">
                      <el-button type="danger" size="mini" @click="handle_exam_delete(props.$index, props.row, $event)">
                        <i class="icofont-trash"></i>
                      </el-button>
                    </el-tooltip>

                    <el-tooltip v-if="props.row.status >11 && rapp === 'genetify' && subject.id_subject == 44" content="Print GENETIFY report" placement="top" effect="light" :open-delay="250">
                      <el-button type="success" size="mini" @click="print_gf_report(props.$index, props.row, $event)">
                        <i class="icofont-file-pdf"></i>
                      </el-button>
                    </el-tooltip>

                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div class="col-sm-6 pagination-info">
            </div>
            <div class="col-sm-6">
                <el-pagination
                  class="pull-right pagination_mezera"
                  @size-change="handleSizeChangePage_e"
                  @current-change="handleCurrentChangePage_e"
                  :current-page.sync="pagination_e.currentPage"
                  :page-sizes="pagination_e.perPageOptions"
                  :page-size="pagination_e.perPage"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="pagination_e.total"
                  background
                  >
                </el-pagination>
            </div>
          </div>
        </div>

      </el-col>
    </el-row>


    <el-dialog :visible.sync="modal_patient" width="80%" headerClasses="justify-content-center" :show-close="true" @close="handle_close_modal">
      <h5 slot="header" class="title title-up"> </h5>
      <div class="row">
        <div class="col-12 ml-auto mr-auto">
          <patient-card got_id_patient="id_patient">
          </patient-card>
        </div>
      </div>
    </el-dialog>


    <el-dialog :visible.sync="modal_exam_detail" width="80%" headerClasses="justify-content-center" :show-close="true" :close-on-click-modal="false">
      <h5 v-if="g_examination" slot="header" class="title title-up">{{ this.g_examination.sample_id }}</h5>
      <div>
        <el-tabs class="col-md-12" type="card" @tab-click="">
          <el-tab-pane label="Sample details">
            <div class="ml-auto mr-auto box-card-modal-01">
              <el-row style="margin: 0px">
                <el-col :span="5" style="padding: 3px">
                  <label>NAME AND LAST NAME<span class="red_label"> (needed for report)</span></label>
                  <el-input v-model="exam_det_sample_name_and_last_name"></el-input>
                </el-col>
                <el-col :span="4" style="padding: 3px">
                  <label>BIRTH DATE<span class="red_label"> (needed for report)</span></label>
                  <el-date-picker
                    v-model="exam_det_birth_date"
                    type="date"
                    placeholder="YYYY-MM-DD"
                    :picker-options="pickerOptions"
                    format="d.M.yyyy"
                    value-format="yyyy-MM-dd"
                    >
                  </el-date-picker>
                </el-col>
                <el-col :span="4" style="padding: 3px; text-align: center">
                  <label>GENDER<span class="red_label"> (needed for report)</span></label>
                  <div>
                    <el-radio v-model="exam_det_gender" label="1">Female</el-radio>
                    <el-radio v-model="exam_det_gender" label="2">Male</el-radio>
                  </div>
                </el-col>
                <el-col :span="6" style="padding: 3px">
                  <label>REFERRING HOSPITAL</label>
                  <el-input v-model="exam_det_referring_hospital"></el-input>
                </el-col>
                <el-col :span="5" style="padding: 3px">
                  <label>ORDERING PHYSICIAN<span class="red_label"> (needed for report)</span></label>
                  <el-input v-model="exam_det_referred_by"></el-input>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>

          <el-tab-pane label="Sample records">
            <div class="ml-auto mr-auto box-card-modal-01">
              <el-row style="margin: 0px">
                <el-col :span="7" style="padding: 3px">
                  <label>SAMPLE ID</label>
                  <el-input v-model="exam_det_sample_id"></el-input>
                </el-col>
                <el-col :span="7" style="padding: 3px">
                  <label>INTERNAL SAMPLE ID<span class="red_label"> (needed for report)</span></label>
                  <el-input v-model="exam_det_int_sample_id"></el-input>
                </el-col>
                <el-col :span="4" style="padding: 3px">
                  <label>PERSONAL ID</label>
                  <el-input v-model="exam_det_personal_id"></el-input>
                </el-col>
                <el-col :span="6" style="padding: 3px">
                  <label>SAMPLE TYPE<span class="red_label"> (needed for report)</span></label>
                  <el-input v-model="exam_det_sample_type"></el-input>
                </el-col>
                <el-col :span="4" style="padding: 3px" >
                  <label>SAMPLE TAKEN</label>
                 <el-date-picker
                    v-model="exam_det_sample_taken"
                    type="date"
                    placeholder="YYYY-MM-DD"
                    :picker-options="pickerOptions"
                    format="d.M.yyyy"
                    value-format="yyyy-MM-dd"
                    >
                  </el-date-picker>
                </el-col>
                <el-col :span="4" style="padding: 3px">
                  <label>SAMPLE RECEIVED</label>
                  <el-date-picker
                    v-model="exam_det_sample_received"
                    type="date"
                    placeholder="YYYY-MM-DD"
                    :picker-options="pickerOptions"
                    format="d.M.yyyy"
                    value-format="yyyy-MM-dd"
                    >
                  </el-date-picker>
                </el-col>
                <el-col :span="6" style="padding: 3px">
                  <label v-if="this.exam_det.id_analysis_type === 2">INDICATION<span class="red_label"> (needed for report)</span></label>
                  <label v-else-if="this.exam_det.id_analysis_type === 1">CANCER TYPE<span class="red_label"> (needed for report)</span></label>
                  <label v-else>---</label>
                  <el-input v-model="exam_det_indication"></el-input>
                </el-col>
                <el-col :span="10" style="padding: 3px">
                </el-col>
              </el-row>

              <el-row style="margin: 0px">
                <el-col :span="12" style="padding: 3px;">
                  <label>HUMAN PHENOTYPE ONTOLOGY (HPO)</label>
                  <fg-input>
                    <el-select
                      v-model="exam_det_hpo"
                      multiple
                      :filterable="true"
                      :filter-method="hpo_filter"
                      :clearable="true"
                      reserve-keyword
                      placeholder="Start typing at least three characters ..."
                      >
                      <el-option
                        v-for="item in g_exam_hpo(exam_det_hpo, hpo_query)"
                        :key="item.hpo_id"
                        :label="item.hpo_term_name"
                        :value="item.hpo_id">
                      </el-option>
                    </el-select>
                  </fg-input>
                </el-col>

                <el-col :span="12" style="padding: 3px;">
                  <label>HPO NOTE</label>
                  <el-input
                    type="textarea"
                    :rows="2"
                    v-model="exam_det_hpo_note">
                  </el-input>
                </el-col>
              </el-row>

              <el-row style="margin: 0px">
                <el-col :span="12" style="padding: 3px;">
                  <label>INTERNATIONAL CLASSIFICATION OF DISEASES (ICD)</label>
                  <fg-input>
                    <el-select
                      v-model="exam_det_icd11"
                      multiple
                      :filterable="true"
                      :filter-method="icd11_filter"
                      :clearable="true"
                      reserve-keyword
                      placeholder="Start typing at least three characters ..."
                      >
                      <el-option
                        v-for="item in g_exam_icd11(exam_det_icd11, icd11_query)"
                        :key="item.id_icd11"
                        :label="item.icd11_search"
                        :value="item.id_icd11">
                      </el-option>
                    </el-select>
                  </fg-input>
                </el-col>

                <el-col :span="12" style="padding: 3px;">
                  <label>ICD NOTE</label>
                  <el-input
                    type="textarea"
                    :rows="2"
                    v-model="exam_det_icd_note">
                  </el-input>
                </el-col>
              </el-row>

              <el-row style="margin: 0px">
                <el-col :span="12" style="padding: 3px;">
                  <label>INDICATION FOR TESTING<span class="red_label"> (needed for report)</span></label>
                  <el-input
                    type="textarea"
                    :rows="4"
                    v-model="exam_det_indication_for_testing">
                  </el-input>
                </el-col>
                <el-col :span="12" style="padding: 3px;">
                  <label>RESULT INTERPRETATION<span class="red_label"> (needed for report)</span></label>
                  <el-input
                    type="textarea"
                    :rows="4"
                    v-model="exam_det_result_interpretation">
                  </el-input>
                </el-col>
              </el-row>

              <el-row style="margin: 0px">
                <el-col :span="12" style="padding: 3px;">
                  <label>EXAMINATION NOTE</label>
                  <el-input
                    type="textarea"
                    :rows="4"
                    v-model="exam_det_exam_note">
                  </el-input>
                </el-col>
                <el-col :span="12" style="padding: 3px;">
                  <label>DESCRIPTION</label>
                  <el-input
                    type="textarea"
                    :rows="4"
                    v-model="exam_det_description">
                  </el-input>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="ml-auto mr-auto">
          <el-row style="margin: 0px">
            <el-col :span="24" style="padding: 20px; text-align: center;">
              <el-button @click="modal_exam_click" type="info">Save</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>


    <el-dialog :visible.sync="modal_exam_qc" width="85%" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true" @closed="modal_exam_qc_closed">
      <h3 slot="header" class="title title-up">  </h3>
      <exam_qc exam_id = "" :app = "app"></exam_qc>
    </el-dialog>


    <el-dialog
      :visible.sync="modal_exam_msi_tmb"
      width="52%"
      custom-class="msi-tmb-dialog"
      headerClasses="justify-content-center"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      >

      <div class="msi-tmb-modal">

        <div class="msi-tmb-title">
          MSI, TMB and HRD summary
        </div>

        <div class="msi-tmb-subtitle">
          Summary of calculated MSI, TMB and HRD metrics for the selected examination
        </div>

        <div class="msi-tmb-sample-box">
          <div class="msi-tmb-sample-item">
            <span class="msi-tmb-sample-label">Examination ID</span>
            <span class="msi-tmb-sample-value">
              {{ getMsiTmbValue('id_examination') !== null ? getMsiTmbValue('id_examination') : '-' }}
            </span>
          </div>

          <div class="msi-tmb-sample-divider"></div>

          <div class="msi-tmb-sample-item">
            <span class="msi-tmb-sample-label">Sample ID</span>
            <span class="msi-tmb-sample-value">
              {{ getMsiTmbValue('sample_id') !== null ? getMsiTmbValue('sample_id') : '-' }}
            </span>
          </div>
        </div>

        <div class="msi-tmb-card-grid">

          <!-- MSI card -->
          <div class="msi-tmb-card">
            <div class="msi-tmb-card-header">
              <div>
                <div class="msi-tmb-card-title">MSI</div>
                <div class="msi-tmb-card-desc">Microsatellite instability</div>
              </div>
            </div>

            <div class="msi-tmb-main-value">
              {{ getMsiTmbValue('msi_percent') !== null ? getMsiTmbValue('msi_percent') : '-' }}
              <span
                v-if="getMsiTmbValue('msi_percent') !== null"
                class="msi-tmb-main-unit"
              >
                %
              </span>
            </div>

            <div class="msi-tmb-metrics">
              <div class="msi-tmb-metric-row">
                <span>Total number of variants</span>
                <strong>
                  {{ getMsiTmbValue('msi_total_number_of_sites') !== null ? getMsiTmbValue('msi_total_number_of_sites') : '-' }}
                </strong>
              </div>

              <div class="msi-tmb-metric-row">
                <span>Number of somatic variants</span>
                <strong>
                  {{ getMsiTmbValue('msi_number_of_somatic_sites') !== null ? getMsiTmbValue('msi_number_of_somatic_sites') : '-' }}
                </strong>
              </div>
            </div>
          </div>

          <!-- TMB card -->
          <div class="msi-tmb-card">
            <div class="msi-tmb-card-header">
              <div>
                <div class="msi-tmb-card-title">TMB</div>
                <div class="msi-tmb-card-desc">Tumor mutational burden</div>
              </div>
            </div>

            <div class="msi-tmb-main-value">
              {{ getMsiTmbValue('tmb') !== null ? getMsiTmbValue('tmb') : '-' }}
            </div>

            <div class="msi-tmb-metrics">
              <div class="msi-tmb-metric-row">
                <span>Total variants</span>
                <strong>
                  {{ getMsiTmbValue('tmb_total_variants') !== null ? getMsiTmbValue('tmb_total_variants') : '-' }}
                </strong>
              </div>

              <div class="msi-tmb-metric-row">
                <span>Variants after filter</span>
                <strong>
                  {{ getMsiTmbValue('tmb_variants_after_filter') !== null ? getMsiTmbValue('tmb_variants_after_filter') : '-' }}
                </strong>
              </div>
            </div>
          </div>

          <!-- HRD card -->
          <div class="msi-tmb-card">
            <div class="msi-tmb-card-header">
              <div>
                <div class="msi-tmb-card-title">HRD</div>
                <div class="msi-tmb-card-desc">
                  Homologous recombination deficiency
                </div>
              </div>
            </div>

            <div class="msi-tmb-main-value">
              {{ getMsiTmbValue('hrd_score') !== null ? getMsiTmbValue('hrd_score') : '-' }}
            </div>

            <div class="msi-tmb-metrics">
              <div class="msi-tmb-metric-row">
                <span>TAI</span>
                <strong>
                  {{ getMsiTmbValue('tai') !== null ? getMsiTmbValue('tai') : '-' }}
                </strong>
              </div>

              <div class="msi-tmb-metric-row">
                <span>LST</span>
                <strong>
                  {{ getMsiTmbValue('lst') !== null ? getMsiTmbValue('lst') : '-' }}
                </strong>
              </div>

              <div class="msi-tmb-metric-row">
                <span>LOH</span>
                <strong>
                  {{ getMsiTmbValue('loh') !== null ? getMsiTmbValue('loh') : '-' }}
                </strong>
              </div>
            </div>
          </div>

          <!-- Empty cell to keep HRD under MSI and preserve two-column layout -->
          <div class="msi-tmb-card-placeholder-empty"></div>

        </div>
      </div>

      <div slot="footer" class="msi-tmb-footer">
        <el-button
          type="info"
          size="mini"
          plain
          @click="copyMsiTmbToClipboard"
        >
          <i class="icofont-copy"></i>
          Copy to clipboard
        </el-button>
      </div>
    </el-dialog>


    <el-dialog
      title="Edit Examination"
      :visible.sync="modal_exam_files"
      width="60%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      custom-class="examination-detail-dialog"
    >
      <h5
        v-if="g_examination"
        slot="header"
        class="title title-up"
      >
        {{ this.g_examination.sample_id }}
      </h5>

      <div class="examination-detail-tabs-wrapper">
        <el-tabs
          v-model="mytab"
          class="examination-detail-tabs"
          @tab-click="load_data_files"
        >
          <el-tab-pane label="FASTQ Files" name="q">
            <mongo-files
              collection="q"
              :modify="true"
              :myfiles="u_f_q"
              :extensions="['gz', 'fastq', ]"
            >
            </mongo-files>
          </el-tab-pane>

          <el-tab-pane
            v-if="rapp !== 'genetify'"
            label="Result Files"
            name="v"
          >
            <mongo-files
              collection="v"
              :modify="false"
              :myfiles="u_f_v"
              :extensions="['vcf', ]"
            >
            </mongo-files>
          </el-tab-pane>

          <el-tab-pane
            v-if="rapp !== 'genetify'"
            label="MultiQC & Metadata Files"
            name="m"
          >
            <mongo-files
              collection="m"
              :modify="false"
              :myfiles="u_f_m"
              :extensions="['csv', 'html', 'xlsx', 'xls', ]"
            >
            </mongo-files>
          </el-tab-pane>

          <el-tab-pane
            v-if="rapp !== 'genetify'"
            label="Other Files"
            name="o"
          >
            <mongo-files
              collection="o"
              :modify="true"
              :myfiles="u_f_o"
              :extensions="[
                'pdf',
                'csv',
                'tsv',
                'xlsx',
                'docx',
                'doc',
                'html',
                'htm',
                'odt',
                'ods',
                'mkv',
                'jpg',
                'png',
              ]"
            >
            </mongo-files>
          </el-tab-pane>

          <el-tab-pane
            v-if="rapp !== 'genetify'"
            label="BAM/BAI Files"
            name="b"
          >
            <mongo-files
              collection="b"
              :modify="false"
              :myfiles="u_f_b"
              :extensions="['bam', 'bai', ]"
            >
            </mongo-files>
          </el-tab-pane>

          <el-tab-pane
            v-if="rapp === 'genetify'"
            label="Result Files"
            name="gf"
          >
            <mongo-files
              collection="gf"
              :modify="true"
              :myfiles="u_f_gf"
              :extensions="['csv', ]"
            >
            </mongo-files>
          </el-tab-pane>

          <el-tab-pane
            v-if="rapp === 'genetify'"
            label="Quality Control"
            name="gf_qc"
          >
            <mongo-files
              collection="gf_qc"
              :modify="true"
              :myfiles="u_f_gf_qc"
              :extensions="['csv', 'pdf', ]"
            >
            </mongo-files>
          </el-tab-pane>

          <el-tab-pane
            v-if="rapp === 'genetify'"
            label="Metadata"
            name="gf_r"
          >
            <mongo-files
              collection="gf_r"
              :modify="true"
              :myfiles="u_f_gf_r"
              :extensions="['csv', ]"
            >
            </mongo-files>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import Vue from 'vue';
  import moment from 'moment';
  moment.locale("cs");
  import {Table, TableColumn, Select, Option, Tabs, TabPane, Tag, Tooltip } from 'element-ui';
  import Button from 'src/components/UIComponents/Button';
  import PPagination from 'src/components/UIComponents/Pagination.vue';
  import Loading from 'src/components/Layout/LoadingMainPanel.vue';
  import Vars from 'src/components/Views/Vars.vue';
  import PatientCard from 'src/components/Views/PatientCard.vue'
  import UserCard from 'src/components/Views/UserProfile/UserProfile/UserCard.vue'
  import MembersCard from 'src/components/Views/UserProfile/UserProfile/MembersCard.vue'
  import ExamQC from 'src/components/Views/ExamQC.vue'
  import MongoFiles from 'src/components/Views/MongoFiles.vue';

  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

  import FileSaver from 'file-saver';
  import axios from 'axios';
  import VueUploadComponent from 'vue-upload-component';
  Vue.component('file-upload', VueUploadComponent);

  Vue.use(Table);
  Vue.use(TableColumn);
  Vue.use(Tabs);
  Vue.use(Select);
  Vue.use(Option);

  export default {
    name: 'exams',
    props: {
    },
    components: {
      PPagination,
      [Tabs.name]: Tabs,
      [TabPane.name]: TabPane,
      [Vars.name]: Vars,
      [Tag.name]: Tag,
      [Tooltip.name]: Tooltip,
      PatientCard,
      UserCard,
      MembersCard,
      [ExamQC.name]: ExamQC,
      [MongoFiles.name]: MongoFiles,


    },
    computed: {
      ...mapState({
        privat_be: state => state.privat_be,
        token: state => state.token,
        application: state => state.application,
        apps: state => state.apps,
        app: state => state.app,
        rapp: state => state.rapp,
        id_biorole: state => state.id_biorole,
        subject: state => state.subject,

        projects: state => state.projects,
        id_project: state => state.id_project,
        id_project_detail: state => state.id_project_detail,
        id_workflow: state => state.id_workflow,
        examinations: state => state.examinations,
        id_examination: state => state.id_examination,
        selected_exams: state => state.selected_exams,
        id_examination_detail: state => state.id_examination_detail,
        loading_e: state => state.loading_e,

        workflows: state => state.procts.workflows,
        user: state => state.user,
        cufi: state => state.cufi,
        pagination_v: state => state.pagination_v,
        sorting_v: state => state.sorting_v,
        patient: state => state.patient,
        id_patient: state => state.id_patient,
        qc_picard_hs: state => state.qc_picard_hs,
        qc_picard_rna: state => state.qc_picard_rna,
        qc_picard_amp: state => state.qc_picard_amp,
        qc_picard_amp_target: state => state.qc_picard_amp_target,
        chart_bar_a: state => state.chart_bar_a,
        vars_order: state => state.vars_order,
        cnvs_selected: state => state.cnvs_selected,
        exam_det: state => state.exam_det,
        l_hpo: state => state.l_hpo,
        l_icd11: state => state.l_icd11,
        pickerOptions: state => state.pickerOptions,

        f_q: state => state.f_q,
        f_m: state => state.f_m,
        f_o: state => state.f_o,
        f_v: state => state.f_v,
        f_b: state => state.f_b,
        f_c: state => state.f_c,
        f_gf: state => state.f_gf,
        f_gf_qc: state => state.f_gf_qc,
        f_gf_r: state => state.f_gf_r,

        u_f_q: state => state.u_f_q,
        u_f_m: state => state.u_f_m,
        u_f_o: state => state.u_f_o,
        u_f_v: state => state.u_f_v,
        u_f_b: state => state.u_f_b,
        u_f_c: state => state.u_f_c,
        u_f_gf: state => state.u_f_gf,
        u_f_gf_qc: state => state.u_f_gf_qc,
        u_f_gf_r: state => state.u_f_gf_r,

      }),

      ...mapGetters({
        g_project: 'g_project',
        g_examination: 'g_examination',
        g_examination_vars: 'g_examination_vars',
        g_examination_for_submit: 'g_examination_for_submit',
        g_exam_hpo: 'g_exam_hpo',
        g_exam_icd11: 'g_exam_icd11',

      }),

      pagedData_e () {
        return this.examinations.slice(this.from_e, this.to_e)
      },

      examinations_data () {
        if (!this.searchQuery_e) {
          this.pagination_e.total = this.examinations.length
          return this.pagedData_e
        }
        let result = this.examinations
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch_e) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery_e)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination_e.total = result.length
        return result.slice(this.from_e, this.to_e)
      },

      to_e () {
        let highBound = this.from_e + this.pagination_e.perPage
        if (this.total_e < highBound) {
          highBound = this.total_e
        }
        return highBound
      },

      from_e () {
        return this.pagination_e.perPage * (this.pagination_e.currentPage - 1)
      },

      total_e () {
        this.pagination_e.total = this.examinations.length
        return this.examinations.length
      },

      modal_patient: {
        get () {
          return this.$store.state.modal_patient;
        },
        set (value) {
          this.$store.commit('m_modal_patient', value);
        }
      },

      modal_exam_detail: {
        get () {
          return this.$store.state.modal_exam_detail;
        },
        set (value) {
          this.$store.commit('m_modal_exam_detail', value);
        }
      },

      modal_exam_files: {
        get () {
          return this.$store.state.modal_exam_files;
        },
        set (value) {
          this.$store.commit('m_modal_exam_files', value);
        }
      },

      modal_exam_qc: {
        get () {
          return this.$store.state.modal_exam_qc;
        },
        set (value) {
          this.$store.commit('m_modal_exam_qc', value);
        }
      },

      modal_exam_msi_tmb: {
        get () {
          return this.$store.state.modal_exam_msi_tmb;
        },
        set (value) {
          this.$store.commit('m_modal_exam_msi_tmb', value);
        }
      },


      exam_det_sample_id: {
        get () { return this.$store.state.exam_det.sample_id; },
        set (value) { let mykey = "sample_id"; this.$store.commit('m_exam_det', {mykey, value}); }
      },

      exam_det_int_sample_id: {
        get () { return this.$store.state.exam_det.int_sample_id; },
        set (value) { let mykey = "int_sample_id"; this.$store.commit('m_exam_det', {mykey, value}); }
      },

      exam_det_personal_id: {
        get () { return this.$store.state.exam_det.personal_id; },
        set (value) { let mykey = "personal_id"; this.$store.commit('m_exam_det', {mykey, value}); }
      },

      exam_det_sample_type: {
        get () { return this.$store.state.exam_det.sample_type; },
        set (value) { let mykey = "sample_type"; this.$store.commit('m_exam_det', {mykey, value}); }
      },

      exam_det_sample_taken: {
        get () { return this.$store.state.exam_det.sample_taken; },
        set (value) { let mykey = "sample_taken"; this.$store.commit('m_exam_det', {mykey, value}); }
      },

      exam_det_sample_received: {
        get () { return this.$store.state.exam_det.sample_received; },
        set (value) { let mykey = "sample_received"; this.$store.commit('m_exam_det', {mykey, value}); }
      },

      exam_det_indication: {
        get () { return this.$store.state.exam_det.indication; },
        set (value) { let mykey = "indication"; this.$store.commit('m_exam_det', {mykey, value}); }
      },

      exam_det_description: {
        get () { return this.$store.state.exam_det.description; },
        set (value) { let mykey = "description"; this.$store.commit('m_exam_det', {mykey, value}); }
      },

      exam_det_indication_for_testing: {
        get () { return this.$store.state.exam_det.indication_for_testing; },
        set (value) { let mykey = "indication_for_testing"; this.$store.commit('m_exam_det', {mykey, value}); }
      },

      exam_det_result_interpretation: {
        get () { return this.$store.state.exam_det.result_interpretation; },
        set (value) { let mykey = "result_interpretation"; this.$store.commit('m_exam_det', {mykey, value}); }
      },

      exam_det_exam_note: {
        get () { return this.$store.state.exam_det.exam_note; },
        set (value) { let mykey = "exam_note"; this.$store.commit('m_exam_det', {mykey, value}); }
      },

      exam_det_icd_note: {
        get () { return this.$store.state.exam_det.icd_note; },
        set (value) { let mykey = "icd_note"; this.$store.commit('m_exam_det', {mykey, value}); }
      },

      exam_det_hpo_note: {
        get () { return this.$store.state.exam_det.hpo_note; },
        set (value) { let mykey = "hpo_note"; this.$store.commit('m_exam_det', {mykey, value}); }
      },

      exam_det_sample_name_and_last_name: {
        get () { return this.$store.state.exam_det.sample_name_and_last_name; },
        set (value) { let mykey = "sample_name_and_last_name"; this.$store.commit('m_exam_det', {mykey, value}); }
      },

      exam_det_birth_date: {
        get () { return this.$store.state.exam_det.birth_date; },
        set (value) { let mykey = "birth_date"; this.$store.commit('m_exam_det', {mykey, value}); }
      },

      exam_det_gender: {
        get () { return this.$store.state.exam_det.gender; },
        set (value) { let mykey = "gender"; this.$store.commit('m_exam_det', {mykey, value}); }
      },

      exam_det_referring_hospital: {
        get () { return this.$store.state.exam_det.referring_hospital; },
        set (value) { let mykey = "referring_hospital"; this.$store.commit('m_exam_det', {mykey, value}); }
      },

      exam_det_referred_by: {
        get () { return this.$store.state.exam_det.referred_by; },
        set (value) { let mykey = "referred_by"; this.$store.commit('m_exam_det', {mykey, value}); }
      },

      exam_det_hpo: {
        get () { return this.$store.state.exam_det.hpo; },
        set (value) { let mykey = "hpo"; this.$store.commit('m_exam_det', {mykey, value}); }
      },

      exam_det_icd11: {
        get () { return this.$store.state.exam_det.icd11; },
        set (value) { let mykey = "icd11"; this.$store.commit('m_exam_det', {mykey, value}); }
      },


      exam_visualisation: {
        get () { return this.$store.state.exam_visualisation; },
        set (value) { this.$store.commit('m_exam_visualisation', value); }
      },



    },


    data () {
      return {
        hpo_query: "",
        icd11_query: "",

        xxxxxxxxx: [],

        progress_bar_colors: [
          {color: '#f56c6c', percentage: 20},
          {color: '#e6a23c', percentage: 40},
          {color: '#5cb87a', percentage: 60},
          {color: '#1989fa', percentage: 80},
          {color: '#6f7ad3', percentage: 100}
        ],
        mytab: "q",

        files: [],
        exam_selections: [],


        formdata_patient: {
          sample_id: 0,
          description: "",
        },


        pagination_e: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50, 100, 250, 500],
          total: 0
        },
        searchQuery_e: '',
        propsToSearch_e: ['sample_id', ],
        tableColumns_e1: [
          {
            prop: 'id_examination',
            label: 'ID',
            minWidth: 60,
            align: "right"
          },
          {
            prop: 'sample_id',
            label: 'SampleID',
            minWidth: 100,
            align: "right"
          },

        ],

        tableColumns_e2: [
          {
            prop: 'description',
            label: 'Description',
            minWidth: 250
          },

        ],

        project_name: "",
        show_run_analyse_button: true,

        msi_tmb_row: null,
      }
    },

    methods: {
      ...mapMutations({
        m_id_examination: 'm_id_examination',
        m_selected_exams: 'm_selected_exams',
        m_vars: 'm_vars',
        m_cnv_data: 'm_cnv_data',
        m_cnv_count: 'm_cnv_count',
        m_polyt_count: 'm_polyt_count',
        m_presel_count_snv: 'm_presel_count_snv',
        m_presel_count_cnv: 'm_presel_count_cnv',
        m_sign_count_snv: 'm_sign_count_snv',
        m_sign_count_cnv: 'm_sign_count_cnv',

        m_modal_transcripts: 'm_modal_transcripts',
        m_modal_patient: 'm_modal_patient',
        m_modal_exam_detail: 'm_modal_exam_detail',
        m_modal_exam_files: 'm_modal_exam_files',
        m_id_examination_detail: 'm_id_examination_detail',
        m_id_patient: 'm_id_patient',
        m_modal_exam_qc: 'm_modal_exam_qc',
        m_modal_exam_msi_tmb: 'm_modal_exam_msi_tmb',
        m_qc_picard_hs: 'm_qc_picard_hs',
        m_qc_picard_rna: 'm_qc_picard_rna',
        m_qc_picard_amp: 'm_qc_picard_amp',
        m_qc_picard_amp_target: 'm_qc_picard_amp_target',
        m_chart_bar_a: 'm_chart_bar_a',
        m_vars_selected_tab: 'm_vars_selected_tab',
        m_exam_det: 'm_exam_det',
        m_cufi_yes: 'm_cufi_yes',
        m_cufi_load: 'm_cufi_load',
        m_cufi_selected: 'm_cufi_selected',

        m_f_q: 'm_f_q',
        m_f_m: 'm_f_m',
        m_f_o: 'm_f_o',
        m_f_v: 'm_f_v',
        m_f_b: 'm_f_b',
        m_f_c: 'm_f_c',
        m_f_gf: 'm_f_gf',
        m_f_gf_qc: 'm_f_gf_qc',
        m_f_gf_r: 'm_f_gf_r',

      }),


      ...mapActions({
        a_examinations: 'a_examinations',
        a_vars: 'a_vars',
        a_cnvs: 'a_cnvs',

        a_show_qc: 'a_show_qc',
        a_examination: 'a_examination',
        a_examination_validate: 'a_examination_validate',
        a_examination_delete: 'a_examination_delete',
        a_examinations_refresh: 'a_examinations_refresh',
        a_patient: 'a_patient',
        a_projects_refresh: 'a_projects_refresh',
        a_notify: 'a_notify',
        a_examination_update: 'a_examination_update',
        a_examination_gf_report: 'a_examination_gf_report',
        a_exam_files_get: 'a_exam_files_get',

        }),


      tableRowClassName({row, rowIndex}) {
        if (row.status > 18) {
          return 'row_0';
        } else if (row.status > 11) {
          return 'row_0';
        } else if (row.status > 9) {
          return 'row_0';
        } else if (row.status > 8) {
          return 'row_0';
        } else if (row.status > 1) {
          return 'row_0';
        } else if (row.status > 0) {
          return 'row_0';
        } else {
          return 'row_0';
        }
      },


      handle_exam_detail (index, row, event) {
        event.stopImmediatePropagation();
        this.m_id_examination_detail(row.id_examination);
        console.log(this.id_examination_detail)
        this.a_examination(row.id_examination);
        this.m_modal_exam_detail(true);
      },


      handle_exam_files (index, row, event) {
        event.stopImmediatePropagation();
        this.m_id_examination_detail(row.id_examination);
        this.a_examination(row.id_examination);
        this.mytab = "q";

        axios.get(process.env.VUE_APP_BE + '/get_files', { withCredentials: true, params: { "id_examination": this.id_examination_detail, "collection": "q" }, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8', }})
          .then(response => {
            this.m_f_q(response.data["f_list"]);
          }, error => {
              console.log(error);
          });

        this.m_modal_exam_files(true);
      },


      handle_exam_validate (index, row, event, type) {
        event.stopImmediatePropagation();
        this.a_examination_validate( {"id_examination": row.id_examination, "act": type} );

        // if (row.status === 10) {
        //   row.status = 11;
        //   this.a_examination( {"cufi": this.cufi, "id_examination": this.id_examination} );
        // } else if (row.status > 10 && row.status < 20) {
        //   row.status = 21;
        //   this.a_examination( {"cufi": this.cufi, "id_examination": this.id_examination} );
        // } else if (row.status > 10 && row.status < 20) {
        //   row.status = 21;
        //   this.a_examination( {"cufi": this.cufi, "id_examination": this.id_examination} );
        // } else {
        //   row.status = 9;
        // }
        // this.m_id_examination_lock(row.id_examination);
        // this.m_modal_project_detail(true);
      },


      handle_run_analyze (event) {
        event.stopImmediatePropagation();
        for (let one of this.g_examination_for_submit) {
          this.a_examination_validate( {"id_examination": one.id_examination, "act": "BP"} );
        }
        this.show_run_analyse_button = false;

        setTimeout(function () { }, 5000);
        this.a_projects_refresh();
      },


      handle_exam_delete (index, row, event) {
        event.stopImmediatePropagation();
        this.a_examination_delete( {'id_examination': row.id_examination} );
      },


      handleShowQC_o (index, row, event, qc_type) {
        event.stopImmediatePropagation();
        this.a_show_qc( { "id_examination": row.id_examination, "type": qc_type } );
      },


      handleModalQC (index, row, event) {
        event.stopImmediatePropagation();
        axios.get(process.env.VUE_APP_BE + '/examination_qc', { withCredentials: true, params: { "id_examination": row.id_examination  }, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8', }, })
            .then(response => {
                this.m_qc_picard_hs(response.data["qc_picard_hs"]);
                this.m_qc_picard_rna(response.data["qc_picard_rna"]);
                this.m_qc_picard_amp(response.data["qc_picard_amp"]);
                this.m_qc_picard_amp_target(response.data["qc_picard_amp_target"]);
                this.m_chart_bar_a(response.data["chart_bar_a"]);
                this.m_modal_exam_qc(true);
            }, error => {
                console.log(error);
            });

      },


      modal_exam_qc_closed (event) {
        this.m_qc_picard_hs( {} );
        this.m_qc_picard_rna( {} );
        this.m_qc_picard_amp( {} );
        this.m_qc_picard_amp_target( [] );
        this.m_chart_bar_a( [] );
      },


      handleModalMSI_TMB (index, row, event) {
        if (event) {
          event.stopImmediatePropagation();
        }

        this.msi_tmb_row = Object.assign({}, row);
        this.m_modal_exam_msi_tmb(true);
      },


      getMsiTmbValue (key) {
        if (!this.msi_tmb_row) {
          return null;
        }

        if (this.msi_tmb_row[key] === null || this.msi_tmb_row[key] === undefined || this.msi_tmb_row[key] === '') {
          return null;
        }

        return this.msi_tmb_row[key];
      },


      handleShowQC (index, row, event) {
        event.stopImmediatePropagation();
        // console.log(event);
        // this.m_id_project_detail(row.id_project);
        let qc_filename = row.sample_id + '_multiqc_report.html';
        console.log(qc_filename);
        axios.get(process.env.VUE_APP_BE + '/showqc', { withCredentials: true, params: { id_project: row.id_project, id_examination: row.id_examination, filename: qc_filename, col: "m" }, headers: { 'Authorization': this.token, 'Content-Type': 'text/html', }, responseType: 'text', })
            .then(response => {
              var myWindow = window.open("", "_blank");
              myWindow.document.write(response.data);
              myWindow.document.close();
            }, error => {
                console.log(error);
            });
      },


      copyMsiTmbToClipboard () {
        const rows = [
          ['Category', 'Metric', 'Value'],
          ['Examination', 'Examination ID', this.getMsiTmbValue('id_examination')],
          ['Examination', 'Sample ID', this.getMsiTmbValue('sample_id')],
          ['MSI', 'Total number of variants', this.getMsiTmbValue('msi_total_number_of_sites')],
          ['MSI', 'Number of somatic variants', this.getMsiTmbValue('msi_number_of_somatic_sites')],
          ['MSI', 'MSI %', this.getMsiTmbValue('msi_percent')],
          ['TMB', 'Total variants', this.getMsiTmbValue('tmb_total_variants')],
          ['TMB', 'Variants after filter', this.getMsiTmbValue('tmb_variants_after_filter')],
          ['TMB', 'TMB', this.getMsiTmbValue('tmb')],
          ['HRD', 'TAI', this.getMsiTmbValue('tai')],
          ['HRD', 'LST', this.getMsiTmbValue('lst')],
          ['HRD', 'LOI', this.getMsiTmbValue('loi')],
          ['HRD', 'HRD score', this.getMsiTmbValue('hrd_score')],

        ];

        const text = rows
          .map(row => row.map(value => this.formatClipboardValue(value)).join('\t'))
          .join('\n');

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text)
            .then(() => {
              this.a_notify({ message: 'MSI/TMB values copied to clipboard.' });
            })
            .catch(error => {
              console.log(error);
              this.copyTextFallback(text);
            });
        } else {
          this.copyTextFallback(text);
        }
      },


      formatClipboardValue (value) {
        if (value === null || value === undefined || value === '') {
          return '-';
        }

        return String(value);
      },


      copyTextFallback (text) {
        const textarea = document.createElement('textarea');

        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.top = '-9999px';
        textarea.style.left = '-9999px';

        document.body.appendChild(textarea);
        textarea.select();

        try {
          const successful = document.execCommand('copy');

          if (successful) {
            this.a_notify({ message: 'MSI/TMB values copied to clipboard.' });
          } else {
            this.a_notify({ message: 'Unable to copy MSI/TMB values to clipboard.' });
          }
        } catch (error) {
          console.log(error);
          this.a_notify({ message: 'Unable to copy MSI/TMB values to clipboard.' });
        }

        document.body.removeChild(textarea);
      },


      handleShowUCR (index, row, event) {
        event.stopImmediatePropagation();
        let qc_filename = row.sample_id + '_undercovered.html';
        axios.get(process.env.VUE_APP_BE + '/showqc', { withCredentials: true, params: { id_project: row.id_project, id_examination: row.id_examination, filename: qc_filename, col: "o" }, headers: { 'Authorization': this.token, 'Content-Type': 'text/html', }, responseType: 'text', })
            .then(response => {
              var myWindow = window.open("", "_blank");
              myWindow.document.write(response.data);
              myWindow.document.close();
            }, error => {
                console.log(error);
            });
      },


      handle_exam_reload (event) {
        event.stopImmediatePropagation();
        this.a_examinations( {"id_project": this.id_project} );
      },


      handle_unavailable (index, row, event) {
        event.stopImmediatePropagation();
        alert(`Not available in trial version.`);
      },


      handle_close_modal () {
        this.m_id_patient ( 0 );
      },


      handle_make_report (index, row, event) {
        event.stopImmediatePropagation();
        // axios.get(this.privat_be + '/test', { withCredentials: true, params: { "xxx": 123 }, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8', } })
        // axios.get(this.privat_be + '/test', { params: { "mycol": "examinations_ext", "myid": 1, "myhash": "ad6d658ae29ee24c02c621a9a05f758c", "filename": "prehled_tema_497.csv" }, headers: { 'Content-Type': 'application/json;charset=UTF-8', }, responseType: 'blob', })
        axios.post(process.env.VUE_APP_BE + '/make_report', {}, { withCredentials: true, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8', }, responseType: 'blob', })
            .then(response => {
                     var blob = new Blob([response.data]);
                     FileSaver.saveAs(blob, "report.pdf");
            }, error => {
                console.log(error);
            });
      },


      load_data_files(tab, event){
        let colls = ["q", "v", "m", "o", "b", "c", "gf", "gf_qc", "gf_r",];
        if (colls.includes(tab.name)) {
          // this.m_collection(tab.name);
          if (tab.name === "c") {
            var _col = "cnv";
          } else {
            var _col = tab.name;
          }

          axios.get(process.env.VUE_APP_BE + '/get_files', { withCredentials: true, params: { "id_examination": this.id_examination_detail, "collection": _col }, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8', }})
              .then(response => {
                if (tab.name === "q") {
                  this.m_f_q(response.data["f_list"]);
                } else if (tab.name === "v") {
                  this.m_f_v(response.data["f_list"]);
                } else if (tab.name === "b") {
                  this.m_f_b(response.data["f_list"]);
                } else if (tab.name === "m") {
                  this.m_f_m(response.data["f_list"]);
                } else if (tab.name === "c") {
                  this.m_f_c(response.data["f_list"]);
                } else if (tab.name === "o") {
                  this.m_f_o(response.data["f_list"]);
                } else if (tab.name === "gf") {
                  this.m_f_gf(response.data["f_list"]);
                } else if (tab.name === "gf_qc") {
                  this.m_f_gf_qc(response.data["f_list"]);
                } else if (tab.name === "gf_r") {
                  this.m_f_gf_r(response.data["f_list"]);
                } else {
                }

              }, error => {
                  console.log(error);
              });
        } else {

        }


      },


      handleCurrentChange(val) {
        if (this.selected_exams.length === 0) {
          this.pagination_v.currentPage = 1;
          this.m_id_examination(val.id_examination);
          this.m_id_examination_detail(val.id_examination);
          this.m_vars([]);
          this.m_cnv_data([]);

          this.m_cnv_count(null);
          this.m_polyt_count(null);
          this.m_presel_count_snv(null);
          this.m_presel_count_cnv(null);
          this.m_sign_count_snv(null);
          this.m_sign_count_cnv(null);

          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "id_examination": val.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "cufi": this.cufi, "selected": this.vars_selected } );
          this.a_cnvs( { "selected": this.cnvs_selected } );

        } else {
          this.$refs.examinations.setCurrentRow();
        }


        // axios.get(process.env.VUE_APP_BE + '/cufi', { withCredentials: true, params: {id_workflow: this.id_workflow}, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8' } })
        //   .then(response => {
        //     this.m_cufi_selected( response.data["id_cufi_default"] );
        //     this.m_cufi_load();

        //   }, error => {
        //     console.log(error);
        //   });


        // this.m_selected_exams([]);
        // this.$refs.examinations.clearSelection();
        // if (val && val.id_examination > 0 && val.status > 8) {
        //   this.pagination_v.currentPage = 1;
        //   this.m_id_examination(val.id_examination);
        //   this.m_id_examination_detail(val.id_examination);
        //   // this.m_vars_selected_tab("b");
        //   this.m_cufi_yes(true);
        //   this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "id_examination": this.id_examination, "id_project": this.id_project, "cufi": this.cufi, "selected": this.vars_selected } );
        // } else if (val && val.id_examination > 0) {
        //   this.m_id_examination(0);
        //   this.m_id_examination_detail(0);
        // } else {
        //   this.m_id_examination(0);
        //   this.m_id_examination_detail(0);
        // }
        // this.show_run_analyse_button = true;

      },


      handleSelectionChange(val) {
        if (val.length > 0) {
          this.$refs.examinations.setCurrentRow();
          this.m_id_examination(0);
          this.m_vars([]);
          this.m_cnv_count(null);
        }

        this.m_vars_selected_tab("default");

        axios.get(process.env.VUE_APP_BE + '/cufi', { withCredentials: true, params: {id_workflow: this.id_workflow}, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8' } })
          .then(response => {
            this.m_cufi_selected( response.data["id_cufi_default"] );
            this.m_cufi_load();
          }, error => {
            console.log(error);
          });

        this.m_cufi_yes(true);
        this.m_selected_exams(val);
        if (val.length > 0) {
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": 0, "selected_exams": this.selected_exams, "id_project": this.id_project, "selected": this.vars_selected } );
        } else {
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected": this.vars_selected } );
        }
      },


      handlePatient(row, event) {
        // event.stopImmediatePropagation();
        this.m_modal_patient(true);
        this.m_id_patient ( row.id_patient );
        this.a_patient( row.hash );
        console.log(row.hash);

      },


      exam_visualisation_change(val) {
        this.m_id_examination(0);
        this.m_selected_exams([]);
        this.$refs.examinations.setCurrentRow();
        this.$refs.examinations.clearSelection();
        // this.m_exam_visualisation(val);
      },


      submit_exam() {
        // this.a_change_interpretation( this.formdata_change_class );
        // this.a_vars( {"order": this.vars_order, "cufi": this.cufi, "id_examination": this.id_examination} );
        this.a_notify({"message": "UPDATE."});
      },


      modal_exam_click() {
        this.a_examination_update();
        this.m_id_examination(0);
        this.$refs.examinations.setCurrentRow();
      },


      fetchEventsList () {
        if (this.id_project > 0) {
          this.a_examinations_refresh( {"id_project": this.id_project} );
        }
      },


      cancelAutoUpdate () {
        clearInterval(this.timer)
      },


      hpo_filter (query) {
        this.hpo_query = query.toLowerCase();
      },


      icd11_filter (query) {
        this.icd11_query = query.toLowerCase();
      },


      handleCurrentChangePage_e(val) {
        this.pagination_e.currentPage = val;
      },


      handleSizeChangePage_e(val) {
        this.pagination_e.perPage = val;
      },


      print_gf_report (index, row, event) {
        event.stopImmediatePropagation();

        this.$confirm('Are you sure?', 'Warning!', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning',
          center: true
        }).then(() => {
          this.a_examination_gf_report( {'id_examination': row.id_examination} );
        }).catch(() => {

        });

      },

    },


    created () {
        this.timer = setInterval(this.fetchEventsList, 60000)
    },


    beforeMount () {
      // this.m_id_project(0);
    },

    mounted () {

    },


    afterDestroy () {
      this.m_id_examination(0);
    },


    beforeDestroy () {
      clearInterval(this.timer)
    },

  }
</script>

<style scoped lang="scss">
.el-table .td-actions{
  button.btn {
    margin-right: 5px;
  }
}

.el-table .cell{
  line-height: 20px !important;
}

.el-table td, .el-table th {
  padding: 3px 0 !important;
}

.el-table .row_0 {
  background: rgb(253, 253, 253) !important;
}

.el-table .row_1 {
  background: rgb(243, 245, 152) !important;
}

.el-table .row_2 {
  background: rgb(248, 221, 171) !important;
}

.el-table .row_9 {
  background: rgb(252, 192, 82) !important;
}

.el-table .row_10 {
  background: rgb(120, 244, 248) !important;
}

.el-table .row_12 {
  background: rgb(154, 240, 168) !important;
}

.el-table .row_19 {
  background: rgb(5, 153, 29) !important;
}

.el-table .row_light_gray {
  background: rgb(243, 243, 243) !important;
}


.el-table .warning-row {
  background: rgb(241, 175, 52) !important;
}

.el-table .success-row {
  background: #06d410 !important;
}

.el-table .info-row {
  background: #8fbdf1 !important;
}

h4 {
  margin-top: 5px !important;
}

.dolu {
  padding-top: 80px !important;
}



.mezera {
  margin-right: 10px;
}

label {
  display: inline-block;
  margin-bottom: 5px !important;
  margin-top: 15px !important;
  text-align: left !important;
  color: #005D72 !important;
  font-size: 13px !important;
  font-weight: 800 !important;
}

.my_label {
  text-align: right !important;
  font-size: 13px !important;
  font-weight: 800 !important;
}

.my_label_blue {
  color: #004080 !important;
  text-align: right !important;
  font-size: 16px !important;
  font-weight: 900 !important;
}


.box-card-modal-01 {
  background: linear-gradient(0deg, #85ABB3, #E1E5E6) !important;
  padding: 20px 20px 50px 20px !important;
  margin-top: 0px !important;
  margin-bottom: 30px !important;
  border-radius: 7px !important;
}

.red_label {
  color: red !important;
}

.pagination_mezera {
  margin-top: 25px !important;
}

.msi-tmb-sample-box {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 560px;
  max-width: 90%;

  margin: 0 auto 28px auto;
  padding: 12px 18px;

  background: #f6f8fa;
  border: 1px solid #dfe5eb;
  border-radius: 8px;
}

.msi-tmb-modal {
  padding: 8px 28px 34px 28px;
}

.msi-tmb-title {
  text-align: center;
  color: #4f5660;
  font-size: 26px;
  font-weight: 500;
  margin-bottom: 6px;
}

.msi-tmb-subtitle {
  text-align: center;
  color: #8a9099;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 24px;
}


.msi-tmb-sample-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 170px;
}

.msi-tmb-sample-label {
  color: #8a9099;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 3px;
}

.msi-tmb-sample-value {
  color: #005d72;
  font-size: 14px;
  font-weight: 800;
}

.msi-tmb-sample-divider {
  width: 1px;
  height: 34px;
  background: #d8dee5;
  margin: 0 28px;
}

.msi-tmb-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 14px;
}

.msi-tmb-card-title {
  color: #005d72;
  font-size: 17px;
  font-weight: 900;
  letter-spacing: 0.3px;
}

.msi-tmb-card-desc {
  color: #8a9099;
  font-size: 12px;
  font-weight: 500;
  margin-top: 2px;
}

.msi-tmb-main-value {
  color: #004080;
  font-size: 34px;
  font-weight: 900;
  line-height: 1.1;
  margin-bottom: 20px;
}

.msi-tmb-main-unit {
  font-size: 18px;
  font-weight: 800;
  margin-left: 3px;
}

.msi-tmb-metrics {
  border-top: 1px solid #edf0f3;
  padding-top: 12px;
}

.msi-tmb-metric-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  color: #5f6770;
  font-size: 13px;
  font-weight: 600;
  padding: 5px 0;
}

.msi-tmb-metric-row strong {
  color: #2f3a45;
  font-size: 13px;
  font-weight: 900;
}

.msi-tmb-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 12px 4px 12px;
}

.msi-tmb-footer .el-button {
  font-weight: 700;
  border-radius: 5px;
}

.msi-tmb-card-grid {
  display: grid;
  grid-template-columns: repeat(2, 390px);
  gap: 24px;
  justify-content: center;
  align-items: stretch;
}

.msi-tmb-card {
  width: 100%;
  min-height: 205px;
  padding: 20px 22px 18px 22px;
  background: #ffffff;
  border: 1px solid #e1e6eb;
  border-radius: 10px;
  box-shadow: 0 6px 18px rgba(31, 45, 61, 0.06);
}

.msi-tmb-card-placeholder-empty {
  width: 390px;
  min-height: 1px;
}

.hrd-card-placeholder {
  background: #fbfcfd;
  border-style: dashed;
}

.hrd-status-badge {
  display: inline-block;
  padding: 4px 8px;
  background: #f2f4f6;
  border: 1px solid #dfe5eb;
  border-radius: 12px;
  color: #7b848f;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;
}

.hrd-main-placeholder {
  color: #8a9099;
  font-size: 22px;
  font-weight: 800;
  line-height: 1.25;
}

.hrd-score-row {
  margin-top: 5px;
  border-top: 1px solid #edf0f3;
  padding-top: 10px;
}

.hrd-score-row span {
  color: #005d72;
  font-weight: 800;
}

.hrd-score-row strong {
  color: #004080;
}

</style>

<style lang="scss">

.examination-detail-dialog {

  .el-dialog__header {

    padding: 20px 20px 12px;

  }

  .el-dialog__body {

    padding: 30px 20px;

  }

  .examination-detail-tabs-wrapper {

    width: 100%;

    padding: 0;

  }

  .examination-detail-tabs {

    width: 100%;

    .el-tabs__header {

      margin-bottom: 15px;

      padding-left: 0;

    }

    .el-tabs__nav-wrap::after {

      height: 1px;

      background-color: #dfe4ea;

    }

    .el-tabs__nav {

      margin-left: 0;

      border: 0;

    }

    .el-tabs__item {

      position: relative;

      padding: 0 28px;

      border: 0;

      font-weight: 500;

      transition: color 0.2s ease;

    }

    .el-tabs__item:first-child {

      padding-left: 0;

    }

    .el-tabs__item:last-child {

      padding-right: 0;

    }

    .el-tabs__item:not(:last-child)::after {

      content: "";

      position: absolute;

      top: 11px;

      right: 0;

      width: 1px;

      height: 18px;

      background-color: #dfe4ea;

    }

    .el-tabs__item:hover {

      color: #409eff;

    }

    .el-tabs__item.is-active {

      color: #409eff;

      font-weight: 600;

    }

    .el-tabs__active-bar {

      height: 3px;

      border-radius: 2px;

      background-color: #409eff;

    }

  }

}

</style>
